;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import svg from "../assets/alternativeIcon.svg"
import SvgAsset from "./SvgAsset"

function AlternativeIcon({ color }) {
  return (
    <SvgAsset
      svg={svg}
      viewBox="0 0 53 44"
      width="40px"
      height="40px"
      color={color ? color : "#AAAAAA"}
    />
  )
}
export default AlternativeIcon
